import { render, staticRenderFns } from "./bankaccount.vue?vue&type=template&id=785b2368&scoped=true&"
import script from "./bankaccount.vue?vue&type=script&lang=js&"
export * from "./bankaccount.vue?vue&type=script&lang=js&"
import style0 from "./bankaccount.vue?vue&type=style&index=0&id=785b2368&prod&lang=scss&scoped=true&"
import style1 from "./bankaccount.vue?vue&type=style&index=1&id=785b2368&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785b2368",
  null
  
)

export default component.exports